import { Component } from '@angular/core';
import { AboutUsComponent } from './about-us.component';

@Component({
  selector: 'about-us',
  templateUrl: './about-us.container.component.html',
  styleUrl: './about-us.container.component.scss',
  imports: [AboutUsComponent],
  standalone: true,
})
export class AboutUsContainerComponent {}
